export default __webpack_public_path__ + "static/scam-tax-season-1eace0a6022bf5a2919cd33e22d4e30b.webp";